import Swiper from 'swiper/bundle';

var sliderContent = document.querySelector(".slide-posts-container")

if (sliderContent) {
    new Swiper(sliderContent, {
        slidesPerView: "auto",
        spaceBetween: 32,
        grabCursor: 'true',


        navigation: {
            nextEl: sliderContent.querySelector(".swiper-button-next"),
            prevEl: sliderContent.querySelector(".swiper-button-prev"),
        }
    });
}
